module.exports = __webpack_public_path__ + "static/media/willo_invite-comma.6835ba61.csv";